import * as styledComponents from 'styled-components'
import merge from 'lodash.merge'

import { theme as BaseTheme } from '@thg-commerce/gravity-theme'

import { theme as SimpleHeaderTheme } from './SimpleHeader/theme'
import { theme as HeaderTheme } from './Header/theme'
import { theme as FooterTheme } from './Footer/theme'
import { theme as ContentHeaderTheme } from './ContentHeader/theme'
import { theme as AccountHomeHeroBannerTheme } from './AccountHomeHeroBanner/theme'
import { theme as LoyaltyHeroBannerTheme } from './LoyaltyHeroBanner/theme'
import {
  StyleWithTheme,
  theme as ProductBlockTheme,
} from './ProductBlock/theme'
import { theme as ProductDescriptionAccordionTheme } from './ProductDescriptionAccordion/theme'
import { PatternThemeInterface, CombinedThemeInterface } from './'

export const patternTheme: PatternThemeInterface = {
  patterns: {
    simpleHeader: SimpleHeaderTheme,
    header: HeaderTheme,
    footer: FooterTheme,
    contentHeader: ContentHeaderTheme,
    productDescriptionAccordion: ProductDescriptionAccordionTheme,
    accountHomeHeroBanner: AccountHomeHeroBannerTheme,
    loyaltyHeroBanner: LoyaltyHeroBannerTheme,
    imageGallery: {
      image: {
        aspectRatio: '1/1',
      },
    },
    productBlock: ProductBlockTheme,
    styleWith: StyleWithTheme,
  },
  widgets: {
    stripBanner: {
      backgroundColor: '#efefff',
      hoverBackgroundColor: '#bfbdff',
      hoverTextColor: '#333333',
      font: {
        entry: 'small',
        style: 'default',
        transform: 'none',
        textColor: '#333333',
        textDecoration: 'none',
      },
    },
    uspBar: {
      backgroundColor: '#f2f2f2',
      iconFill: '#333333',
      font: {
        entry: 'small',
        style: 'default',
        transform: 'none',
        textColor: '#333333',
        textDecoration: 'none',
      },
      hoverFont: {
        entry: 'small',
        style: 'default',
        transform: 'none',
        textColor: '#333333',
        textDecoration: 'none',
      },
    },
  },
}

const theme = merge({}, BaseTheme, patternTheme)

const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
  withTheme,
  useTheme,
} = (styledComponents as unknown) as styledComponents.ThemedStyledComponentsModule<
  CombinedThemeInterface
>

export {
  theme,
  styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
  withTheme,
  useTheme,
}
